<!-- @format -->

<template>
	<disabled-text
		v-if="disabled && showDisabledText"
		:value="
			value && props.isTimestamp
				? dayjs(value).format(props.format)
				: props.type === 'time'
				? (value && dayjs(value).format(props.format)) || ''
				: value?.toString() || ''
		"
	/>
	<van-field
		v-else
		v-bind="$attrs"
		v-model="value"
		is-link
		readonly
		:disabled="disabled"
		style="padding: 0"
		@click="
			() => {
				if (!disabled) {
					showPicker = true;
				}
			}
		"
	/>
	<van-popup v-model:show="showPicker" round position="bottom" teleport="body">
		<template v-if="type === 'time'">
			<van-time-picker :columns-type="['hour', 'minute', 'second']" @confirm="onConfirm" @cancel="showPicker = false" />
		</template>

		<template v-else>
			<van-date-picker @confirm="onConfirm" @cancel="showPicker = false" />
		</template>
	</van-popup>
</template>

<script setup lang="ts">
	import dayjs from 'dayjs';
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: any;
		type?: any;
		format?: string;
		disabled?: boolean;
		showDisabledText?: boolean;
	}

	const showPicker = ref(false);

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
		showDisabledText: true,
		isTimestamp: false,
		isTenTimestamp: false,
	});

	const onConfirm = ({ selectedValues }) => {
		showPicker.value = false;
		if (props.type === 'time') {
			value.value = selectedValues.join(':');
		} else {
			value.value = selectedValues.join('-');
		}
	};

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue && props.isTimestamp
				? props.isTenTimestamp
					? +`${props.modelValue}000`
					: +props.modelValue
				: props.type === 'time'
				? (props.modelValue && dayjs(props.modelValue, props.format)) || ''
				: props.modelValue;
		},
		set(val) {
			emit(
				'update:modelValue',
				val && props.isTimestamp
					? props.isTenTimestamp
						? dayjs(val).unix()
						: dayjs(val).valueOf()
					: props.type === 'time'
					? (val && dayjs(val).format(props.format)) || ''
					: val || '',
			);
		},
	});
</script>

<style scoped lang="scss"></style>
